import { createSlice } from "@reduxjs/toolkit";

const clientNavigationSlice = createSlice({
  name: "clientNavigation",
  initialState: {
    activeTab: "Home",
    unreadCount: 0
  },
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    incrementNotification: (state) => {
      state.unreadCount += 1;
    },
    resetNotifications: (state) => {
      state.unreadCount = 0;
    },
  },
});

export const { setActiveTab, incrementNotification, resetNotifications } = clientNavigationSlice.actions;
export default clientNavigationSlice.reducer;